package one.healthium.login.ui.magic_link

data class MagicLinkUiOptions(
    val username: String = "",
) {
    val isValid: Boolean = username.isNotBlank()
}
